import React from 'react';
import { ArrowBack, ArrowForward } from '@material-ui/icons';
import IconButton from '@material-ui/core/IconButton';
import SectretaryChip from './SecretarChip';

class DateIntervals extends React.Component {
  constructor(props) {
    super(props);

    this.handleClickLeft = this.handleClickLeft.bind(this);
    this.handleClickRight = this.handleClickRight.bind(this);
    this.sideScroll = this.sideScroll.bind(this);

    this.topSideBar = React.createRef();
  }

  componentDidMount() {
    this.topSideBar.current.scrollLeft = this.props.currentDateInterval * 101.7 - 101.7*2;
  }

  handleClickRight() {
    this.sideScroll('right', 15, 200, 10);
  }

  handleClickLeft() {
    this.sideScroll('left', 15, 200, 10);
  }

  sideScroll(direction, speed, distance, step) {
    let scrollAmount = 0;
    const slideTimer = setInterval(() => {
      if (direction === 'left') {
        this.topSideBar.current.scrollLeft -= step;
      } else {
        this.topSideBar.current.scrollLeft += step;
      }
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);
  }

  render() {
    return (
      <div style={{ maxWidth: '1022px', position: 'relative', marginLeft: '10px' }}>
        <div style={{
          width: '30px',
          height: '32px',
          position: 'absolute',
          top: 0,
          left: 0,
          cursor: 'pointer'
        }}
        >
          <IconButton
            color="primary"
            onClick={this.handleClickLeft}
            style={{
              zIndex: 20,
              width: '30px',
              height: '30px',
              outline: 'none'
            }}
          >
            <ArrowBack />
          </IconButton>
        </div>
        <div
          style={{
            padding: '0px 0px',
            overflow: 'hidden',
            width: 'auto',
            margin: '8px 35px -3px 35px',
            position: 'relative'
          }}
          ref={this.topSideBar}
        >
          <div style={{
            width: '100px',
            whiteSpace: 'nowrap'
          }}
          >
            {this.props.dateIntervals.map(({ key, name, count }) => {
              let selected = false;
              if (this.props.currentDateInterval === key) {
                selected = true;
              }

              return (
                <SectretaryChip
                  key={key}
                  info={name}
                  extra={count}
                  click={() => {
                    this.props.onDateChange(key);
                  }}
                  selected={selected}
                />
              );
            })}
          </div>
        </div>
        <div style={{
          width: '30px',
          height: '32px',
          position: 'absolute',
          top: 0,
          right: 0,
          cursor: 'pointer'
        }}
        >
          <IconButton
            color="primary"
            onClick={this.handleClickRight}
            style={{
              zIndex: 20,
              width: '30px',
              height: '30px',
              outline: 'none'
            }}
          >
            <ArrowForward />
          </IconButton>
        </div>
      </div>
    );
  }
}

export default DateIntervals;



// WEBPACK FOOTER //
// ./src/components/DateIntervals.js